import { configureStore } from "@reduxjs/toolkit";
import platformReducer from "../features/platform/platformSlice";
import toastNotificationReducer from "../features/toast-notification/toastNotificationSlice";
import userReducer from "../features/user/userSlice";
import collectionReducer from "../features/collection/collectionSlice";
import keywordReducer from "../features/keyword/keywordSlice";
import topicReducer from "../features/topic/topicSlice";
import groupReducer from "../features/group/groupSlice";
import contentReducer from "../features/content/contentSlice";
import linkReducer from "../features/link/linkSlice";
import adReducer from "../features/ad/adSlice";
import frontendReducer from "../features/frontend/frontendSlice";
import searchReducer from "../features/search/searchSlice";
import authReducer from "../features/auth/authSlice";
import chatReducer from "../features/chat/chatSlice";
import courseReducer from "../features/course/courseSlice";
import quotaReducer from "../features/quota/quotaSlice";
import aiChatReducer from "../features/chatembed/chatEmbedSlice";
import moderationReducer from "../features/moderation/moderationSlice";
import userFeedbackReducer from "../features/userFeedback/userFeedbackSlice";

export const reducer = {
  platform: platformReducer,
  toastNotification: toastNotificationReducer,
  user: userReducer,
  content: contentReducer,
  collection: collectionReducer,
  topic: topicReducer,
  link: linkReducer,
  ad: adReducer,
  frontend: frontendReducer,
  auth: authReducer,
  chat: chatReducer,
  group: groupReducer,
  keyword: keywordReducer,
  search: searchReducer,
  course: courseReducer,
  quota: quotaReducer,
  aiChat: aiChatReducer,
  moderation: moderationReducer,
  userFeedback: userFeedbackReducer,
};

export default configureStore({
  reducer
});
